import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Construction } from 'lucide-react'

export function LessonPage() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <Construction className="size-16 text-gray-300 mb-4" />
      <h2 className="text-xl font-bold text-gray-900 mb-2">준비 중</h2>
      <p className="text-gray-500 mb-6">학습 플레이어를 새롭게 준비하고 있습니다.</p>
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 px-4 py-2 text-sm text-primary-600 border border-primary-200 rounded-lg hover:bg-primary-50"
      >
        <ArrowLeft className="size-4" />
        돌아가기
      </button>
    </div>
  )
}
